
export default {
  settings: {
    endpointsSectionTitle: 'Service Endpunkte (oder ganze URL)',
    language: 'Sprache (Language)',
    appLocale: 'App Sprache',
    unit: 'Einheit',
    areaUnit: 'Flächeneinheit',
    saveToLocalStorage: 'Im Browser speichern',
    routeInstructions: 'Sprache der Wegbeschreibung',
    randomizedIsochroneColors: 'Zufällige Isochronen Farben',
    distanceMarkers: 'Distanzmarkierungen',
    elevationProfile: 'Höhenprofil',
    mapSettings: 'Kartenansicht und extra Infos',
    defaultMapSettingsRestored: 'Standardeinstellungen wiederhergestellt.',
    endpointsTitle: {
      directions: 'Directions',
      isochrones: 'Isochrones',
      geocodeSearch: 'Geocode search',
      autocomplete: 'Geocode autocomplete',
      pois: 'POIs',
      reverseGeocode: 'Geocode reverse'
    },
    apiKey: 'API Schlüssel',
    customApiKey: 'Benutzerdefinierter API Schlüssel',
    apiBaseUrl: 'API Basis URL',
    invalidSettingsValue: 'Ungültige Eingaben. Bitte Felder überprüfen oder Standard wiederherstellen.',
    restoreDefaults: 'Zurücksetzen',
    advanced: 'Erweitert',
    mapSettingsSaved: 'Einstellungen gespeichert',
    alwaysFitBounds: 'Immer auf Größe der Route zoomen',
    routeExtraInfo: 'Extra Infos',
    mapViewOptions: 'Kartenansicht',
    advancedSettingsWarning: 'Nachfolgende Einstellungen bitte nur ändern, wenn Sie wissen was Sie tun.',
    customOverlayerTileProviderUrl: 'Benutzerdefinierte Overlayer-Anbieter-URL',
    customTileProviderUrl: 'Spezielle Kartenkachel-Provider URL',
    defaultTilesProvider: 'Standard Kartenkachel-Provider',
    customTileProviderUrlHint: 'https://domain.tld/pfad/{z}/{x}/{y}.ext?optionalerSchlüssel=Wert',
    prioritizeSearchingForNearbyPlaces: 'Ortssuche priorisiert nahe Orte',
    defaultProfile: 'Standard Profil',
    compressDataUrlSegment: 'URL Segment hinter /data/ komprimieren',
    autoFitHighlightedBounds: 'Auto-Zoom zu selektiertem Wegabschnitt',
    reloadToApplyLanguageChangeTitle: 'App muss neu geladen werden',
    reloadToApplyLanguageChangeText: 'Um die Sprache komplett umzustellen, muss die App neu geladen werden. Jetzt neu laden?',
    resetShownOnceTooltips: 'Hinweise erneut anzeigen',
    convertStopAfterRouteEndingToDestination: 'Konvertieren den Stopp nach dem Ende der Route zum Ziel',
    skipAllSegments: 'gerade Route für alle Segmente',
    useStopOptimization: 'Optimize the route when a stop is created using drag and drop'
  }
}
